import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';
import createPersistedState from "vuex-persistedstate";
import setUserData from '@/utils/setUserData';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      token: null,
    },
    setting: {
      teacherChatApproval: false,
      currency: '',
      clientType: null,
      report_card_grading: null,
      school_start_time: null,
      school_end_time: null,
    },
    settingLoaded: false,
    xappFormData: {
      id: null,
      title: '',
      url: '',
      type: 0,
      start_date: '',
      end_date: '',
      items_arr: {},
      initial_screen: '',
    },
    cameFromItemsPage: false,
  },

  mutations: {
    storeUser(state, userData) {
      state.user = userData;
    },
    storeToken(state, userToken) {
      state.user.token = userToken;
    },
    logout(state) {
      state.user = [];
    },
    setStudentNo(state, studentNo) {
        state.studentNo = studentNo;
    },
    setChatApproval(state, status) {
      state.setting.teacherChatApproval = status;
      state.settingLoaded = true;
    },
    setCurrency(state, currency) {
      state.setting.currency = currency;
    },
    setSchoolStartTime(state, value) {
      state.setting.school_start_time = value;
    },
    setSchoolEndTime(state, value) {
      state.setting.school_end_time = value;
    },
    setReportCardSetting(state, report_card_grading) {
      state.setting.report_card_grading = report_card_grading;
    },
    setAppFormData(state, formData) {
      state.xappFormData = { ...state.xappFormData, ...formData};
    },
    setHasAppliedUsers(state, value) {
      state.hasAppliedUsers = value;
    },
    setCameFromItemsPage(state, status) {
      state.cameFromItemsPage = status;
    },
    resetAppFormData (state) {
      state.xappFormData = {
        title: '',
        url: '',
        type: 0,
        start_date: '',
        end_date: '',
      }
    },
    setInitialScreen(state, initialScreen) {
      state.initialScreen = initialScreen;
    },
    setClientType(state, type) {
      state.setting.clientType = type;
    }
  },

  actions: {
    login({ commit }, credentials) {
      return axios.post("login", credentials).then(({ data }) => {

        // Customize
        const account = setUserData(data.account);
        commit("storeUser", account);
        // Customize

        commit("storeToken", data.token);
      });
    },
    loginByBtn({ commit }, credentials) {
      return axios.post('employee/login', credentials)
        .then(({ data }) => {
          // Customize
          const account = setUserData(data.data);
          commit("storeUser", account);
          // Customize
          
          commit("storeToken", data.token);
        });
    },
    getSetting({ commit, state }) {
      if (state.user.campus_id) {
        return axios
              .get("/setting/" + state.user.campus_id)
              .then(({ data }) => {
                commit("setReportCardSetting", data.report_card_grading);
                commit("setChatApproval", data.teacher_chat_approval == 1 ? true : false);
                commit("setCurrency", data.currency || '');
                commit("setSchoolStartTime", data.school_start_time ?? null);
                commit("setSchoolEndTime", data.school_end_time ?? null);
                commit("setClientType", data.client_type || 'school');
              })
              .catch(error => {
                if (error.response && error.response.status == 401) {
                  commit('logout');
                  window.location.replace('login');
                }
              });
      }
    },
    refreshTeacherRoles({ commit, state }) {
      if (!state.user?.teacher_no) {
        return Promise.resolve();
      }

      return axios
        .get("/teacher/session-roles")
        .then(({ data }) => {
          const token = state.user.token;
          const account = setUserData({
            ...state.user,
            class_teacher_types: data.class_teacher_types || [],
            subject_teachers: data.subject_teachers || [],
          });
          commit("storeUser", account);
          commit("storeToken", token);
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            commit("logout");
            window.location.replace("login");
          }
        });
    },
  },

  plugins: [createPersistedState()],

})
